import App from './App';
import { createRoot } from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import store from './store';
import ErrorBoundary from 'src/utils/ErrorBoundary'
import SessionQuerys from "./content/applications/SessionQuerys";
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <SnackbarProvider
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        maxSnack={3}
        preventDuplicate={false}
        autoHideDuration={3000}
      >
        <Provider store={store}>
          <SessionQuerys>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </SessionQuerys>
        </Provider>
      </SnackbarProvider>
    </BrowserRouter>
  </HelmetProvider>
);

serviceWorker.unregister();
